(function() {
    'use strict';

    const API_URL = 'https://hogo-umbrella-api.onrender.com/api/invites';
    const API_SECRET = 'hogo-umbrella-d4cibe5du9e2dg-rgd';

    // Função para criar assinatura HMAC
    async function createSignature(customerId, timestamp) {
        const data = `${customerId}:${timestamp}`;
        const encoder = new TextEncoder();
        const keyData = encoder.encode(API_SECRET);
        const messageData = encoder.encode(data);

        const cryptoKey = await crypto.subtle.importKey(
            'raw',
            keyData,
            { name: 'HMAC', hash: 'SHA-256' },
            false,
            ['sign']
        );

        const signature = await crypto.subtle.sign(
            'HMAC',
            cryptoKey,
            messageData
        );

        return Array.from(new Uint8Array(signature))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
    }

    // Função principal que busca os cupons ativos (lista completa)
    async function fetchActiveInvites(customerId) {
        if (!customerId || customerId === 'null' || customerId === 'undefined') {
            console.warn('[Hogo API] Cliente não autenticado.');
            return null;
        }

        const timestamp = Math.floor(Date.now() / 1000);
        const signature = await createSignature(customerId, timestamp);

        try {
            const response = await fetch(`${API_URL}/wallet/${customerId}?type=active&page=1&limit=50`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-shopify-customer-id': customerId,
                    'x-shopify-timestamp': timestamp.toString(),
                    'x-shopify-signature': signature
                }
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const result = await response.json();
            
            // Salva no sessionStorage
            sessionStorage.setItem('hogo_active_invites', JSON.stringify(result.data));
            sessionStorage.setItem('hogo_invites_count', result.meta?.total || result.data.length);
            
            //console.log('[Hogo API] Cupons carregados:', result.meta.total);
            
            return result;

        } catch (error) {
            console.error('[Hogo API] Erro ao buscar cupons:', error);
            return null;
        }
    }

    // ⭐ NOVA FUNÇÃO: Verificar se tem cupons ativos (true/false + contagem)
    async function checkActiveInvites(customerId) {
        if (!customerId || customerId === 'null' || customerId === 'undefined') {
            console.warn('[Hogo API] Cliente não autenticado.');
            return { hasInvites: false, count: 0 };
        }

        const timestamp = Math.floor(Date.now() / 1000);
        const signature = await createSignature(customerId, timestamp);

        try {
            const response = await fetch(`${API_URL}/check-active/${customerId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-shopify-customer-id': customerId,
                    'x-shopify-timestamp': timestamp.toString(),
                    'x-shopify-signature': signature
                }
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const result = await response.json();
            
            // Salva só a contagem no sessionStorage
            sessionStorage.setItem('hogo_has_invites', result.hasInvites);
            sessionStorage.setItem('hogo_invites_count', result.count);
            
            //console.log('[Hogo API] Status:', result.hasInvites ? `${result.count} cupons ativos` : 'Sem cupons');
            
            return result;

        } catch (error) {
            console.error('[Hogo API] Erro ao verificar cupons:', error);
            return { hasInvites: false, count: 0 };
        }
    }

    // Expõe as funções globalmente
    window.HogoWalletAPI = {
        fetch: fetchActiveInvites,        // Lista completa de cupons
        checkActive: checkActiveInvites   // ← NOVO: Só true/false + count
    };

})();